"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHexFromDecimal = void 0;
var getHexFromDecimal = function (number) {
    return "0x" + number.toString(16).toUpperCase();
};
exports.getHexFromDecimal = getHexFromDecimal;
